import { render, staticRenderFns } from "./FullAnnuityNotHandle.vue?vue&type=template&id=46f50f64"
import script from "./FullAnnuityNotHandle.vue?vue&type=script&lang=js"
export * from "./FullAnnuityNotHandle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports